// MVP: el usuario normal queda ligado al flujo del primer botón que pulsó en
// la home (evaluate o pitch). La elección definitiva vive en el backend
// (user.chosenFlow) y sigue al usuario en cualquier dispositivo; localStorage
// sólo guarda la elección hecha ANTES de autenticarse, que AuthContext
// sincroniza con el backend tras login/registro.
export type MvpFlow = 'evaluate' | 'pitch';

const PENDING_KEY = 'mvp-flow-pending';

export function getPendingFlow(): MvpFlow | null {
  const value = localStorage.getItem(PENDING_KEY);
  return value === 'evaluate' || value === 'pitch' ? value : null;
}

export function setPendingFlow(flow: MvpFlow): void {
  localStorage.setItem(PENDING_KEY, flow);
}

export function clearPendingFlow(): void {
  localStorage.removeItem(PENDING_KEY);
}
